import { cn } from "@drpcrd/utils/shared";
import { NutcakeSquirrel } from "../icons/nutcake-squirrel";

type AuthSidebarProps = {
  className?: string;
  logoClassName?: string;
};

/**
 * Standalone sidebar for auth pages — a fixed-width rail showing only the
 * logo mark. Not expandable/collapsible/resizable, so it's kept separate
 * from the dashboard `Sidebar` rather than bending that component's
 * expand/collapse logic to fake a permanently-collapsed state.
 *
 * `className`/`logoClassName` default to the existing sizing so callers
 * that don't pass them keep today's look; pass overrides to match a
 * page-specific design spec (e.g. talent-agency's sign-in page).
 */
export const AuthSidebar = ({
  className = "w-8",
  logoClassName = "h-4 w-4",
}: AuthSidebarProps = {}) => (
  <aside
    className={cn(
      "flex h-dvh shrink-0 flex-col items-center border-r border-r-neutral-500 bg-white pt-2",
      className,
    )}
  >
    <NutcakeSquirrel fill="#5e32c7" className={logoClassName} />
  </aside>
);
